import { Col, Container, Row } from "react-bootstrap";
import styles from "./HomePage.module.css";
import { useEffect, useState } from "react";

const HomePage = () => {
    const [email, setEmail] = useState("");

    const menus = [
        {
            url: "/match-specification",
            label: "Match Specification",
            img: "icons/match.png",
            allowed_to: [
                "admin@carandx.com",
                "marketing@carandx.com",
                "winyu2myat193@gmail.com",
                "ws@carandx.com",
                "rp@carandx.com",
                "cal@carandx.com",
                "pavithran@carandx.com",
            ],
        },
        {
            url: "/expected-results",
            label: "Expected Results",
            img: "icons/expected-result.png",
            allowed_to: [
                "admin@carandx.com",
                "marketing@carandx.com",
                "winyu2myat193@gmail.com",
                "ws@carandx.com",
                "rp@carandx.com",
                "cal@carandx.com",
                "pavithran@carandx.com",
            ],
        },
        {
            url: "/specs-rating-categories",
            label: "Spces Rating",
            img: "icons/rating.png",
            allowed_to: [
                "admin@carandx.com",
                "marketing@carandx.com",
                "winyu2myat193@gmail.com",
                "ws@carandx.com",
                "rp@carandx.com",
                "cal@carandx.com",
                "pavithran@carandx.com",
            ],
        },
        {
            url: "/vehicles",
            label: "Vehicles",
            img: "icons/vehicle.png",
            allowed_to: [
                "admin@carandx.com",
                "marketing@carandx.com",
                "winyu2myat193@gmail.com",
                "ws@carandx.com",
                "rp@carandx.com",
                "cal@carandx.com",
                "pavithran@carandx.com",
                "ous@carandx.com"
            ],
        },
        {
            url: "/cms-edit",
            label: "CMS",
            img: "icons/cms.png",
            allowed_to: [
                "admin@carandx.com",
                "marketing@carandx.com",
                "ws@carandx.com",
                "rp@carandx.com",
                "cal@carandx.com",
                "pavithran@carandx.com",
            ],
        },
        {
            url: "/shipping",
            label: "Shipping Tracking",
            img: "icons/ship.png",
            allowed_to: [
                "admin@carandx.com",
                "marketing@carandx.com",
                "ws@carandx.com",
                "rp@carandx.com",
                "cal@carandx.com",
                "pavithran@carandx.com",
            ],
        },
        {
            url: "/bl",
            label: "Bill Of Landing",
            img: "icons/folders.png",
            allowed_to: [
                "admin@carandx.com",
                "marketing@carandx.com",
                "ws@carandx.com",
                "rp@carandx.com",
                "cal@carandx.com",
                "pavithran@carandx.com",
            ],
        },
        {
            url: "/delivery",
            label: "Delivery",
            img: "icons/delivery.png",
            allowed_to: [
                "admin@carandx.com",
                "marketing@carandx.com",
                "ws@carandx.com",
                "rp@carandx.com",
                "cal@carandx.com",
                "pavithran@carandx.com",
            ],
        },
        {
            url: "#",
            label: "Settings",
            img: "icons/settings.png",
            allowed_to: [
                "admin@carandx.com",
                "marketing@carandx.com",
                "ws@carandx.com",
                "rp@carandx.com",
                "cal@carandx.com",
                "pavithran@carandx.com",
            ],
        },
    ];

    const loadUser = function () {
        let email = localStorage.getItem("user_email");
        if (email) {
            setEmail(email);
        }
    };

    useEffect(() => {
        loadUser();
    }, []);

    return (
        <div className={styles.mainContainer} style={{ paddingTop: 100 }}>
            <Container>
                <Row>
                    {menus.map((menu) => (
                        <>
                            {menu.allowed_to.includes(email) && (
                                <Col xs="2" className="text-center mt-5">
                                    <a href={menu.url}>
                                        <img
                                            src={menu.img}
                                            className={styles.icon}
                                        />
                                    </a>
                                    <p className={styles.label}>{menu.label}</p>
                                </Col>
                            )}
                        </>
                    ))}
                </Row>
            </Container>
        </div>
    );
};

export default HomePage;
